import React from "react";

export const SaveCancelButtons = ({onSave, saveBtnText = "שליחת שינויים", cancelBtnText = "ביטול עריכה", onClose}) => (
    <div className="admin-order-modal-save-cancel-buttons">
        <span className="admin-order-modal-cancel-button" onClick={onClose}>
            {cancelBtnText}
        </span>
        <span className="admin-order-modal-save-button" onClick={onSave}>
            {saveBtnText}
        </span>
    </div>
);
